import { Td } from 'components/Td/Td'
import { CircleButton, ScheduleOption, ScheduleOptionsWrapper, ScheduleWeeklyCard } from 'pages/Shifts/Shifts.styled'
import { Flex, ProfilePicture, Table, TableWrapper, Th, Tr } from 'styling/GlobalStyles'
import { addZero, convertMinsToHrsMins } from 'utils/helpers'
import { v4 } from 'uuid'
import { BodyText, OtherText, ParagraphText } from 'styling/Typography'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Avatar from '../../assets/images/profileAvatar.png'
import { AppDispatch, RootState } from 'store'
import { setConfirmModal } from 'features/global/globalSlice'
import { addWorkSchedule, addWorkScheduleArray, clearWorkSchedule, getWorkSchedules, removeWorkSchedule } from 'features/work-schedules/workScheduleSlice'
import { ISingleShift } from 'types/shifts.interface'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { clearShiftsList, getShifts } from 'features/shifts/shiftsSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { IGetAllWorkSchedulesSingleResponse } from 'types/api/workScheduleApi.interface'
import { CheckBox } from 'components/CheckBox/CheckBox'
import { SunriseIcon } from './Icons/SunriseIcon'
import { SunsetIcon } from './Icons/SunsetIcon'
import { RotationIcon } from './Icons/RotationIcon'
import { BeachIcon } from './Icons/BeachIcon'
import { DrinkIcon } from './Icons/DrinkIcon'
import { HeartIcon } from './Icons/HeartIcon'
import { MinusIcon } from './Icons/MinusIcon'
import { SunIcon } from './Icons/SunIcon'
import { FloatingDropdown } from 'components/FloatingDropdown/FloatingDropdown'

export const ScheduleWeeklyDisplay = ({ params, workSchedules }: { params: any, workSchedules: IGetAllWorkSchedulesSingleResponse[] }) => {
    const [checked, setChecked] = useState([])
    const [openDropdown, setOpenDropdown] = useState<{ userId: number, day: number, anchor: HTMLElement } | null>(null)
    const dispatch = useDispatch<AppDispatch>()
    const ref = useRef()
    const { shifts } = useSelector((store: RootState) => store.shifts)
    const [isOutHouse, setIsOutHouse] = useState(false)

    useQueryPagination({ fetchFunctions: [getWorkSchedules], cleanUpFunctions: [clearWorkSchedule], params, otherFunctions: [() => setChecked([])], dontFetchIfEmpty: ['dateTo', 'dateFrom'] })

    useEffect(() => {
        dispatch(getShifts({ page: 1, limit: 99 }))
        return () => {
            dispatch(clearShiftsList())
        }
    }, [])

    const getIcon = (iconName: string, color: string) => {
        switch (iconName) {
            case 'sunrise':
                return <SunriseIcon stroke={color || '#ff9900'} />
            case 'sunset':
                return <SunsetIcon stroke={color || '#ff9900'} />
            case 'rotation':
                return <RotationIcon stroke={color || '#ff9900'} />
            case 'beach':
                return <BeachIcon stroke={color || '#ff9900'} />
            case 'drink':
                return <DrinkIcon stroke={color || '#ff9900'} />
            case 'heart':
                return <HeartIcon stroke={color || '#ff9900'} />
            case 'sun':
                return <SunIcon stroke={color || '#ff9900'} />
            default:
                return <SunriseIcon stroke={color || '#ff9900'} />
        }
    }

    const getHeaderDays = () => {
        const arr = []
        const day = new Date(params.dateFrom)
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

        for (let i = 1; i <= 7; i++) {
            const currentDay = `${days[day.getDay()]} ${addZero(day.getDate())}. ${addZero(
                day.getMonth() + 1,
            )}.`
            arr.push(<Td w='10%' noTooltip key={v4()} text={currentDay} />)

            day.setDate(day.getDate() + 1)
        }

        return arr
    }

    interface ShiftWithDate {
        date: string;
        shift: ISingleShift;
    }

    const handleOuthouse = (e, v: boolean) => {
        e.stopPropagation()
        setIsOutHouse(v)
    }

    const handleWorkSchedule = (shiftId: number, userId: number, date) => {
        if (!shiftId) {
            dispatch(
                setConfirmModal({
                    isOpen: true,
                    onSave: async () => {
                        await dispatch(removeWorkSchedule({ userId, date }))
                    },
                    word: 'unassign shift',
                }),
            )

            return
        }
        setChecked([])

        checked.length < 2
            ? dispatch(addWorkSchedule({ userId, date, shiftId, isOutHouse }))
            : dispatch(addWorkScheduleArray({ users: checked, date, shiftId, isOutHouse }))
    }

    const renderShiftInputs = (dates: ShiftWithDate[], userId: number) => {
        const arr = []
        const day = new Date(params.dateFrom)

        for (let i = 1; i <= 7; i++) {

            const shiftForTheDay: ShiftWithDate = dates.find((date) => {
                return new Date(date.date).getTime() === new Date(day).getTime()
            })
            const handleDropdown = (e: React.MouseEvent<HTMLDivElement>) => {
                const anchor = e.currentTarget
                if (openDropdown && openDropdown.userId === userId && openDropdown.day === i) {
                    setOpenDropdown(null)
                } else {
                    setOpenDropdown({ userId, day: i, anchor })
                }
            }
            const color = shiftForTheDay?.shift?.color ? '#' + shiftForTheDay?.shift.color : '#ff9900'

            const getDay = () => {
                const dt = new Date(params.dateFrom)
                dt.setDate(dt.getDate() + i - 1)
                return dt
            }

            arr.push(
                <Td w='10%' h='100%' key={userId} noTooltip>
                    <ScheduleWeeklyCard color={shiftForTheDay?.shift ? color : null} onClick={handleDropdown}>
                        <Flex center gap='0.5rem' >
                            {shiftForTheDay?.shift?.name ? getIcon(shiftForTheDay?.shift?.icon, shiftForTheDay?.shift?.iconColor ? '#' + shiftForTheDay?.shift?.iconColor : '#fff') : <MinusIcon stroke='#fff' />}
                            <Flex column >
                                <BodyText
                                    style={{
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        maxWidth: '100%',
                                        color: shiftForTheDay?.shift?.textColor ? '#' + shiftForTheDay?.shift?.textColor : '#fff',
                                    }}
                                    weight='bold' >{shiftForTheDay?.shift?.name || 'Not Set'}
                                </BodyText>
                                {shiftForTheDay?.shift && <ParagraphText style={{ color: shiftForTheDay?.shift?.textColor ? '#' + shiftForTheDay?.shift?.textColor : '#fff' }} >
                                    {convertMinsToHrsMins(shiftForTheDay.shift.shiftStart)}-{convertMinsToHrsMins(shiftForTheDay.shift.minutes, shiftForTheDay.shift.shiftStart)}
                                </ParagraphText>}
                            </Flex>

                        </Flex>

                        <FloatingDropdown
                            open={!!(openDropdown && openDropdown.userId === userId && openDropdown.day === i)}
                            onOpenChange={(o) => { if (!o) setOpenDropdown(null) }}
                            reference={openDropdown && openDropdown.userId === userId && openDropdown.day === i ? openDropdown.anchor : null}
                        >
                            <ScheduleOptionsWrapper>
                                {shiftForTheDay?.shift && <ScheduleOption onClick={() => handleWorkSchedule(null, userId, getDay())} >
                                    <OtherText color='red' >Remove Shift</OtherText>
                                </ScheduleOption>}
                                {shifts.map(s => <ScheduleOption onClick={() => handleWorkSchedule(s.id, userId, getDay())} key={s.id}>
                                    <OtherText>{s.name}</OtherText>
                                </ScheduleOption>)}
                                <Flex width='100%' column padding='0 1rem' >
                                    <ScheduleOption onClick={(e) => handleOuthouse(e, false)} style={{ borderTop: '1px solid white' }} >
                                        <CheckBox state={!isOutHouse} title='Inhouse' />
                                    </ScheduleOption>
                                    <ScheduleOption onClick={(e) => handleOuthouse(e, true)} >
                                        <CheckBox state={isOutHouse} title='Outhouse' />
                                    </ScheduleOption>
                                </Flex>
                            </ScheduleOptionsWrapper>
                        </FloatingDropdown>
                    </ScheduleWeeklyCard>
                </Td>,
            )
            day.setDate(day.getDate() + 1)
        }

        return arr
    }

    const toggle = (id: number) => {
        if (checked.includes(id)) {
            setChecked((prev) => {
                return prev.filter((item) => item !== id)
            })
        } else {
            setChecked((prev) => (!prev ? [id] : [...prev, id]))
        }
    }

    const toggleAll = () => {
        if (checked.length < workSchedules.length) {
            for (const a of workSchedules) {
                const id = a.id

                if (!checked.includes(id)) {
                    setChecked((prev) => [...prev, id])
                }
            }
        } else {
            setChecked([])
        }
    }

    return <TableWrapper>
        <Table ref={ref}>
            <Th>
                <Td w='3%' noTooltip>
                    <CircleButton
                        onClick={toggleAll}
                        checked={checked.length === workSchedules?.length}
                    />
                </Td>
                <Td w='27%' text='Employee' noTooltip />
                {getHeaderDays()}
            </Th>
            {workSchedules?.length ?
                workSchedules.map((item: IGetAllWorkSchedulesSingleResponse) => {
                    const id = item.id
                    return (
                        <Tr big key={id}>
                            <Td noTooltip w='30%'>
                                <Flex center gap='1rem'>
                                    <CircleButton
                                        orange
                                        checked={checked.includes(id)}
                                        onClick={() => toggle(id)}
                                    />
                                    <ProfilePicture mr='20'>
                                        <img
                                            src={item.profileImageUrl || Avatar}
                                            alt=''
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null
                                                currentTarget.src = Avatar
                                            }}
                                        />
                                    </ProfilePicture>
                                    <BodyText>{item.firstName + ' ' + item.lastName}</BodyText>
                                </Flex>
                            </Td>
                            {renderShiftInputs(item.schedules, item.id)}
                        </Tr>
                    )
                }) : <NoItems title='Employees' />}
        </Table>
    </TableWrapper>
}